
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import AuditsListView from "./audits-list.html";

angular.module("audits", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('audits', {
                url: "/audits",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('audits.list', {
                url: "/list",
                controller: "AuditsListCtrl",
                template: AuditsListView,
                data: { pageTitle: 'Auditoria' }
            })
        ;
    }])
;